import React, { Suspense, useContext, useEffect, useState } from 'react';
import { useT } from '../../../../helpers/i18n';

import { faArrowDown } from '@fortawesome/pro-regular-svg-icons'

import * as appContext from '../../../../components/AppContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { fetchBuilderSettingByKey } from "../../../../helpers/MethodHelper";
import CustomModal from "../../../CustomModal";

const isHtmlEmpty = ( html ) => !html || html.replace( /<[^>]*>/g, '' ).trim().length === 0;

export default function ProfileSection({ profile, readMoreBrief = null, readMoreDetails = null }) {
  const t = useT();

  const hasReadMore = !isHtmlEmpty( readMoreBrief ) || !isHtmlEmpty( readMoreDetails );
  const [ readMoreOpen, setReadMoreOpen ] = useState( false );

  const profileViewType = useSelector(
    state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_homepage_profile_view_type')
  );

  const isColumned = profileViewType == '1';
  const isCentered = profileViewType != '1';

  const extraClasses = isCentered ? " text-center" : " text-full-alignment";

  function getEmbedUrl(url) {
    const match = url.match(/(?:v=|\/shorts\/|\/embed\/|youtu\.be\/)([^?&/]+)/);
    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
  }
  const embedUrl = profile && profile.video && profile.video;

  const readMoreModal = () => {

    const appendPaddingCheck = () => {
      if (embedUrl) {
        return " p-0";
      } else if (!isCentered) {
        return " p-l-35";
      }
    };

    return (
      hasReadMore && (
        <>
          <div className="row">
            <div className={"col-12" + (isCentered ? " text-center" : "")}>
              <p className="small">
                <button
                  className={"btn-link text-link " + appendPaddingCheck()} 
                  onClick={() => setReadMoreOpen(true)}
                >
                  {t('common.readMore')}
                </button>
              </p>
            </div>
          </div>

          <CustomModal
            modalName="modal_profile_desc"
            className="stick-up"
            modalSize="lg"
            closeModal={() => setReadMoreOpen(false)}
            show={readMoreOpen}
            Title={<h3 className="text-overflow mt-0">{profile.title}</h3>}
          >
            <div className="modal-body">
              {!isHtmlEmpty(readMoreBrief) && (
                <div dangerouslySetInnerHTML={{ __html: readMoreBrief }} />
              )}

              {!isHtmlEmpty(readMoreDetails) && (
                <div dangerouslySetInnerHTML={{ __html: readMoreDetails }} />
              )}
            </div>
          </CustomModal>
        </>
      )
    );
  };

  return (
    <>
      {
        isColumned == true ?
          <>
            <section className="bg-master-lightest p-b-100 p-t-100">
              <div className="container">
                <p className="block-title hint-text no-margin">{profile.title}</p>
                <div className="row">
                  {embedUrl ?
                    <>
                      <div className="col-sm-6 pe-sm-3">
                        <h2 className="m-t-5 hidden-xs">{profile.motto}</h2>
                        <div className={"p-t-0  md-p-t-15" + extraClasses} dangerouslySetInnerHTML={{ __html: profile.description }} />
                        {readMoreModal()}
                      </div>
                      <div className={"col-sm-6 no-padding xs-p-l-15 xs-p-r-15 d-flex justify-content-center align-items-center " + extraClasses}>
                        <iframe
                          src={getEmbedUrl(embedUrl)}
                          allowFullScreen
                          height="315"
                          title="Video Player"
                          className='w-100 rounded m-t-20 mr-sm-3'
                        ></iframe>
                      </div>
                    </>
                    :
                    <>
                      <div className="col-sm-5 col-md-4">
                        <h2 className="m-t-5 hidden-xs">{profile.motto}</h2>
                      </div>
                      <div className={"col-sm-7 col-md-8 no-padding xs-p-l-15 xs-p-r-15 d-flex justify-content-center align-items-center " + extraClasses}>
                        {
                          hasReadMore ?
                            <div className="w-100">
                              <div className={"p-t-0 p-l-35 md-p-l-5 md-p-t-15" + extraClasses} dangerouslySetInnerHTML={{ __html: profile.description }} />
                              {readMoreModal()}
                            </div>
                            :
                            <div className={"p-t-0 p-l-35 md-p-l-5 md-p-t-15" + extraClasses} dangerouslySetInnerHTML={{ __html: profile.description }} />
                        }
                      </div>
                    </>
                  }
                </div>
              </div>
            </section>
          </>
          :
          <>
            <section id="descriptions" className=" p-b-50 p-t-50">
              <div className="container text-center">
                <div className="row">
                  <div className="col-sm-8 offset-sm-2">
                    <h6 className="block-title m-b-0">{profile.title}</h6>
                    <h1 className="m-t-5 light">{profile.motto}</h1>
                    <div className={"m-t-20" + extraClasses} dangerouslySetInnerHTML={{ __html: profile.description }} />
                    {embedUrl ? 
                      <>
                        <iframe
                          src={getEmbedUrl(embedUrl)}
                          allowFullScreen
                          height="315"
                          title="Video Player"
                          className='w-100 rounded m-t-20'
                        ></iframe>
                        {readMoreModal()}
                      </>
                      :
                      <>{readMoreModal()}</>
                    }
                    <FontAwesomeIcon icon={faArrowDown} className={'fs-24 m-t-20'} style={{ color: "#d1d1d1" }} />
                  </div>
                </div>
              </div>
            </section>
          </>
      }
    </>
  )
}